const baseLease = {
  id: 'id-a1b2c3',
  savingsGSTThisMonth: 46.45,
  savingsToDateGST: 152.21,
  savingsToDateTax: 95.33,
  vehicleRego: 'ABC123',
  vehicleImg:
    'https://storage.googleapis.com/ecx-de-db-uat-jato_vehicle_images/Jato/400/BMW/SERIES 8/2021/2CO-4.JPG',
  term: 36,
  currentMonth: 9,
  currentBalance: 256.23,
  leaseType: 'Novated Fully Budgeted',
  leaseActive: true,
  carLeaseCost: 100,
  runningBudgetCost: 220,
  otherCosts: 24,
  totalLeaseCost: 344,
  impactOnTakeHomePay: 404,
  leaseStartDate: '2021-01-26T00:00:00.000Z',
  leaseEndDate: '2024-01-26T00:00:00.000Z',
  leaseAnnualKM: 15000,
  interestRate: 4.3,
  financier: 'St George',
  residualValue: 20000,
  primaryDocuments: [
    {
      label: 'Signed Novated Lease Contract',
      url: 'http://www.africau.edu/images/default/sample.pdf'
    },
    {
      label: 'Payout Schedule',
      url: 'http://www.africau.edu/images/default/sample.pdf'
    }
  ],
  registrationPaidUntil: '2022-01-26T00:00:00.000Z',
  vehicleDescription: 'Toyota Yaris Sedan',
  vehicleVin: '743gkf768g979',
  insurer: 'Allianz',
  insuranceRenewalDate: '2022-01-26T00:00:00.000Z',
  allianzDocuments: [
    {
      label: 'Allianz Insurance - Distributor Agreement',
      url: 'http://www.africau.edu/images/default/sample.pdf'
    },
    {
      label: 'Allianz Insurance - Product Disclosure Statement',
      url: 'http://www.africau.edu/images/default/sample.pdf'
    }
  ],
  otherDocuments: [
    {
      label: 'Minor Damage Repair Insurance',
      url: 'http://www.africau.edu/images/default/sample.pdf'
    },
    {
      label: 'Example Document',
      url: 'http://www.africau.edu/images/default/sample.pdf'
    }
  ]
};

export default {
  data: {
    getLease: { ...baseLease },
    getLeases: [
      {
        ...baseLease,
        id: 'ABC123',
        vehicleRego: 'BCJ302'
      },
      {
        ...baseLease,
        id: 'ABC124',
        currentBalance: -100.23,
        vehicleRego: 'OOE032'
      },
      {
        ...baseLease,
        id: 'ABC125',
        vehicleRego: 'RAA122'
      },
      {
        ...baseLease,
        id: 'ABC126',
        vehicleRego: 'HVH123'
      },
      {
        ...baseLease,
        id: 'ABC127',
        vehicleRego: 'HVH124'
      },
      {
        ...baseLease,
        id: 'ABC128',
        vehicleRego: 'HVH125'
      },
      {
        ...baseLease,
        id: 'ABC129',
        currentBalance: -900.23,
        vehicleRego: 'HVH126'
      }
    ]
  }
};
